module.exports = __webpack_public_path__ + "static/media/user-protection-success.241e425a.svg";